<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
<loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
      <b-row>
        <b-col>
         <br/><br/><br/>
        </b-col>
      </b-row>
       

      <b-row>
        <b-col>
          
          <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosTablaHojasBienvenida"
                :fields="encabezados"  
                responsive
                 
              >

              <template v-slot:cell(fechaCita)="row">
                {{ row.item.fechaCita | formatoFechaCorta }}
              </template>
              
              <template v-slot:cell(botonImprimir)="row">
                 <div>
                  <b-button variant="success" @click="verHojaBienvenida(row)">Ver Hoja De Bienvenida</b-button> 
                </div> 
              </template>
              
              <template v-slot:cell(fechaImpresionHojaBienvenida)="row">
                <b-alert show variant="success" v-if="row.item.fechaImpresionHojaBienvenida != null">Ya se generó la descarga de la hoja el dia {{row.item.fechaImpresionHojaBienvenida | formatoFechaHoraTexto}}</b-alert>
                <b-alert show variant="primary" v-else>No se ha generado una descarga de la hoja </b-alert>
                
              </template>
              <template v-slot:cell(fechaNotificacionCorreo)="row">  
                <b-alert show variant="success" v-if="row.item.fechaNotificacionCorreo != null">
                  Se realizó el envio de notificación el dia  {{row.item.fechaNotificacionCorreo | formatoFechaHoraTexto}} debido a que no se realizó la descarga en el tiempo establecido el dia 
                 
                </b-alert> 
                <b-alert show variant="primary" 
                  v-if="row.item.fechaNotificacionCorreo == null && row.item.fechaImpresionHojaBienvenida == null"> 
                  Se realizará envio de notificación si no cumple con el tiempo definido de descarga de la hoja  
                </b-alert>
                 <b-alert show variant="primary" 
                  v-if="row.item.fechaImpresionHojaBienvenida != null"> 
                  No se realizará envio de notificación
                </b-alert>
              </template>
              
              
              
                 
              </b-table>
              
              
        </b-col>
      </b-row>
            
             <b-row>
        <b-col>
        <br/><br/><br/><br/><br/><br/>
        </b-col>
      </b-row>
   
      
     <HojaBienvenida :nombrePaciente="nombrePaciente" :tagMotivoCita="tagMotivoCita" :idCita="idCita"
     :idTipoDenticion="idTipoDenticion" :nombreTutor="nombreTutor">
                </HojaBienvenida>  
              
      <b-row>
        <b-col>
         <br/><br/><br/><br/><br/><br/>
         <br/><br/><br/><br/><br/><br/>
        </b-col>
      </b-row>
  </div>
</template>

<script> 
export default {
  name: "HistorialHojasBienvenida",
  components: {
  },
  props: {
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    idPaciente : null,
    loading: false,
    
    datosTablaHojasBienvenida : [],
    
    encabezados: [
     
      {
        key: "nombreClinica",
        label: "nombreclinica",
        sortable: true,
      },      
      {
        key: "fechaCita",
        label: "Fecha Cita", 
        sortable: true, 
      },      
      {
        key: "horaInicioString",
        label: "Hora Inicio",
        sortable: true,
      },      
      {
        key: "horaFinalString",
        label: "Hora Fin",
        sortable: true,
      },       
      {
        key: "nombreDoctor",
        label: "Doctor",
        sortable: true,
      },      
      {
        key: "sillon",
        label: "Sillon",
        sortable: true,
      },      
      {
        key: "estatusCita",
        label: "Estatus de la Cita",
        sortable: true,
      },      
      {
        key: "nombreDoctor",
        label: "Doctor",
        sortable: true,
      },     
      {
        key: "botonImprimir",
        label: "Imprimir hoja de bienvenida",
        sortable: true,
      },       
      {
        key: "fechaImpresionHojaBienvenida",
        label: "Fecha Impresion Hoja Bienvenida",
        sortable: true,
      },      
      {
        key: "fechaNotificacionCorreo",
        label: "Fecha Notificacion Correo",
        sortable: true,
      },
   
    ],  
    idCita: null,
    nombrePaciente: null,
    tagMotivoCita: null,
    idTipoDenticion: null,
    nombreTutor: null,
  }),
  watch: {},
  computed: {},

  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idPaciente = this.$route.params.id;
    this.getObtenerDatosHistoriaHojasDeBienvenida();
    
  },
  mounted() {},
  methods: {
      getObtenerDatosHistoriaHojasDeBienvenida(){
        this.loading = true;
        this.datosTablaHojasBienvenida = [];
        const parametros = {idPaciente: Number(this.idPaciente)}
        this.$http
        .post(
          this.$api +
            "cita/obtener/historialhojasbienvenida", parametros
        )
        .then((response) => {
          this.datosTablaHojasBienvenida = response.data.data;
         
        })
        .catch((error) => {
          console.error(error);
        }).finally(() => {
           this.loading = false;
        }); 
      },
      verHojaBienvenida(row){ 
        this.loading = true;  
        this.nombrePaciente= null;
        this.tagMotivoCita= null;
        this.idTipoDenticion = null;
        this.nombreTutor = null;
        this.idCita = row.item.idCita;
        this.$http
          .get(
            this.$api +
              "cita/obtener/datoshojabienvenida?idCita="+row.item.idCita
          )
          .then((response) => {
            let datos = response.data.data;
            this.nombrePaciente= datos.nombrePaciente,
            this.tagMotivoCita= datos.tagMotivoCita,
            this.idCita = row.item.idCita; 
            this.idTipoDenticion = datos.idTipoDenticion;
            this.nombreTutor = datos.nombreTutor;
            this.$bvModal.show("modal-hoja-bienvenida"); 
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
        
        
      }, 
      
      
      

  },
};
</script>
